<div class="confirmable-input-select">
  <ng-container [ngSwitch]="type">
    <div class="input-wrapper">
      <div *ngIf="startIcon" class="prefix">
        <i class="{{startIcon}}"></i>
      </div>
      <!-- SELECT -->
      <select id="tsc-select" *ngSwitchCase="'select'" [ngModel]="value" (ngModelChange)="onValueChange($event)"
        class="ts-select" (keydown)="onKeydown($event)" (focusout)="onFocusOut()">
        <option *ngFor="let opt of options" [value]="opt.value">{{opt.text}}</option>
      </select>
      <!-- INPUT -->
      <input *ngSwitchCase="'input'" [type]="inputType" [ngModel]="value" (ngModelChange)="onValueChange($event)"
        class="input" [attr.maxlength]="maxLength" (keydown)="onKeydown($event)" (focusout)="onFocusOut()">

      <input *ngSwitchCase="'inputnumeric'" type="text" [ngModel]="value" (ngModelChange)="onValueChange($event)"
        class="input edp-num-input" [attr.maxlength]="maxLength" (keydown)="onKeydown($event)" (focusout)="onFocusOut()">
      <!-- DATE -->
      <teiasoft-datetime *ngSwitchCase="'date'" [value]="value" [noMargin]="true" [size]="'s'" [type]="'date'"
        [isRequired]="true" [disabled]="false" [isMobile]="false" (onChange)="onValueChange($event)"
        [dateFormat]="globals!.dateFormat!" (keydown)="onKeydown($event)" (focusout)="onFocusOut()"></teiasoft-datetime>
    </div>
  </ng-container>
  <ng-container *ngIf="isModified()">
    <i *ngIf="isModified()" class="fas fa-times-circle undo-icon" (mousedown)="undoChange($event)"></i>
    <i *ngIf="!isModified()" class="fas fa-times-circle undo-icon-disabled"></i>
    <!-- <i class="fas fa-check-circle confirm-icon" (click)="onConfirmChangeClick($event)"></i> -->
  </ng-container>
</div>